module.exports = __webpack_public_path__ + "img/case1.f8edd887.png";